/** @jsxImportSource @emotion/react */
"use client";

import type {
  CommunitiesStatsTimeGraphType,
  GetDateByRangeProps,
} from "@packages/sdk";
import {
  getDateByRange,
  useRequestCommunitiesStatsTimeGraph,
} from "@packages/sdk";

import { useErrorNotification } from "../../../../../hooks/useErrorNotification.emotion";
import { LineChart } from "../../../../_base/dashboard/charts/LineChart/LineChart.emotion";

export type LineChartStatProps = {
  id: number;
  range?: GetDateByRangeProps["range"] | "all";
  type: CommunitiesStatsTimeGraphType;
};

export const LineChartStat = ({
  id,
  range = "all",
  type,
}: LineChartStatProps) => {
  const { query: queryTimeGraph } = useRequestCommunitiesStatsTimeGraph({
    id,
    startDate: range === "all" ? undefined : getDateByRange({ range }),
    type,
  });

  useErrorNotification({
    isError: queryTimeGraph.isError,
  });

  return (
    <LineChart
      data={queryTimeGraph.data?.data}
      loading={!queryTimeGraph.data}
    />
  );
};

LineChartStat.displayName = "LineChartStat";
